import type { ServiceReportItem } from "@entity/ServiceReport";

/**
 * Splits a service label into its service and subservice names.
 * Preserves the original rules: a hyphen takes precedence over the Engage prefix.
 * @param value - Report item containing the service label.
 * @returns Names used to group rows in the service report.
 */
export function getServiceNameSubname(value: Pick<ServiceReportItem, "service">): { name: string; subName: string } {
  const service = { name: value.service, subName: value.service };

  if (value.service.includes("-")) {
    const serviceNames = value.service.split("-");
    service.name = serviceNames[0].trim();
    service.subName = serviceNames[1].trim();
  } else if (value.service.includes("Engage")) {
    const separatorIndex = value.service.indexOf(" ");
    service.name = value.service.substring(0, separatorIndex);
    service.subName = value.service.substring(separatorIndex + 1);
  }

  return service;
}
